<style lang="less" scoped>
@import url('./index.less');
</style>

<template>
  <div class="health-advice">
    <div>
      <div class="top">
        <div class="title">
          <div class="my">
            我的关注
          </div>
          <div class="area" @click="show = true">
            <i class="iconfont" style="margin-right:0.05rem;">&#xe73d;</i>
            <span>{{areaValue.length === 0 ? '全国':areaValue.map(obj=>obj.name).join(' ')}}</span>
            <span style="color:#999999;margin-left:4px;">
              <Icon name="arrow-down" />
            </span>
          </div>
        </div>
        <div class="tab" v-if="tabSelect &&  tabSelect.online_diagnostic">
          <Button size="small" @click="handleTagClick('全部')" :class='{"active":active === "全部","button":true}' plain  >全部 </Button>
          <Button size="small" @click="handleTagClick(tab.name)" :class='{"active":active === tab.name,"button":true}' plain  v-for="tab in tabSelect.online_diagnostic.tag" :key="tab.name">{{tab.name}} </Button>
        </div>
      </div>
      <div class="center">
        截止{{lastUpdateTime}}，共{{total}}家医院
      </div>
      <SimpleCard v-for="(item,index) in listData" :key="index" :title='item.hospital' :isNew="item.is_new"  style="border-bottom:1px solid #F1EFF2;" class='van-clearfix' @click="handleClick(item)">
        <div class="content" style="color:#666666">{{item.title}}</div>
        <div slot="footer" class="footer">
          <!-- <div class="label_wrap">
            <label>来源：</label>
            <div>{{item.channel_source}}</div>
          </div> -->
          <div class="label_wrap">
            <label>发布日期：</label>
            <div>{{item.publish_date}}</div>
          </div>
        </div>
      </SimpleCard>
      <div><Chatbot /></div>
      <div class="empty" v-if="listData.length === 0">
        <Empty />
      </div>
    </div>
      <!-- 城市选择 -->
    <Popup 
      v-model="show"
      position="bottom"
      :style="{ height: '30%' }">
      <Area
        :area-list="areaList" 
        :columns-num="2"
        @confirm="confirmHandle"
        @cancel="cancelHandle"
      />
    </Popup>
  </div>
</template>
<script>
import { HttpRequest} from 'utils/'
import { debounce, statisticalHandle, getDate } from 'utils/baseMethods.js'
import { Toast } from 'vant'
import areaListData from '@/data/area'
import { mapState } from 'vuex'
export default {
  name:'HealthAdvice',
  data(){
    return {
      tabs:[],
      show:false,
      active:'全部',
      loading:false,
      finished:false,
      error:false,
      listData:[ ],
      pageSize:0,
      total:0,
      lastUpdateTime:'',
      refreshing:false,
      areaList:areaListData,
      areaValue:[],
      date:'',
    }
  },
  computed:{
      ...mapState({
        area:state=>state.location.area,
        tabSelect:state=>state.tabSelect.tabSelect
      })
  },
  created() {
     // 查看是否有缓存
    try {
      let areaValue = this.$route.query.areaValue
      if (areaValue){
        this.$set(this,'areaValue',JSON.parse(areaValue))
      }
    }catch(e){
      this.areaValue = []
    }
    this.lastUpdateTime = getDate()
    document.title = '线上问诊'
    this.fetchData(10)
    this.$nextTick(()=>{
      this.$el.onscroll = debounce(()=>{
        const scrollHeight = this.$el.scrollHeight
        const scrollTop = this.$el.scrollTop
        const clientHeight = this.$el.clientHeight
     
        if(scrollHeight - (clientHeight + scrollTop) <= 50 ){
          if (this.total !== this.listData.length) {
            this.fetchData(this.pageSize + 10)
          }
        }
      },100)
    })
    this.$store.dispatch('location/getLocation')
   
  },
  watch:{
    area:{
      handler:function(value){
        if (!this.$route.query.areaValue && value.length ){
          this.areaValue = value
          this.fetchData()
        }
      },
      deep:true,
      immediate:true
    }
  },
  methods:{
    handleTagClick(item){
      this.active = item
      this.fetchData()
    },
    handleClick(item){
      if (item.url) {
         this.$router.push({
          query:{
            areaValue:JSON.stringify(this.areaValue)
          }
        })
        statisticalHandle(item)
        window.open(item.url)
        window.localStorage.setItem('healthAdviceArea',JSON.stringify(this.areaValue))
        return 
      } 
    Toast.fail('跳转链接错误，请联系管理员');
    },
    async fetchData(pageSize = this.pageSize){
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      });
     const response = await HttpRequest({
        url:'/professional/online_diagnostics/',
        params:{
          page:1,
          page_size:pageSize,
          county_code:'',
          city_code: this.areaValue[1] ?this.areaValue[1].code + '' :'',
          province_code:this.areaValue[0] ? this.areaValue[0].code + '' : '',
          tag__contains: this.active === '全部' ? '' : this.active,
        }
      })
      Toast.clear()
      this.total = response.count
      this.pageSize = response.page_size,
      // this.lastUpdateTime  = response.last_add_time
      this.listData = response.results
      return response
    },
    confirmHandle(data) {
      this.show = false
      this.areaValue = data
      console.log(data,'data')
      this.fetchData()
    },
    cancelHandle() {
      this.show = false
    }
  },
}
</script>
<style lang="less" scoped>
.health-advice{
  width:100%;
  height: 100%;
  overflow:auto;
  .top{
    background:#ffffff;
    padding:0 0.16rem;
    padding-top: 0.19rem;
    padding-bottom: 0.16rem;
    .tab{
      margin-top:14px;
    }
    .title{
      display: flex;
      align-items: center;
      justify-content:space-between;
      .my{
        font-family:PingFangSC-Semibold,PingFang SC;
        color:#333333;
        font-size:20px;
        font-weight:bold;
        margin-left:0.1rem;
        position: relative;
      }
       .my:before{
          content:'';
          width:0.03rem;
          height: 20px;
          position: absolute;
          left: -0.1rem;
          top: 0.05rem;
          background:#FE7922;
        }
      .area{
        color:#FE7922;
        font-size:14px;
        font-family:PingFangSC-Regular,PingFang SC;
        display:flex;
        align-items: center;
      }
    }
  }
  .button{
    margin-right:0.1rem;
    background:rgba(248,248,248,1);
    color:#999999;
    margin-bottom:0.1rem;
    border-radius:3px;

  }
  .active{
    background:rgba(255,237,234,1);
    color:#FE7922;
  }
  .center{
    padding-left:0.16rem;
    height:0.34rem;
    color:#999999;
    background:rgba(244,244,244,1);
    line-height:0.34rem;
  }
  .footer{
      color:#999999;
      >div{
        display: inline-flex;
        width:50%;
      }
    }
    .list{
      height: auto;
      overflow: scroll;
    }
}
</style>